import React from "react";
import styles from "./index.module.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { BsFuelPumpDieselFill } from "react-icons/bs";
import { GiSteeringWheel } from "react-icons/gi";
import { GrManual } from "react-icons/gr";
import { BsArrowUpRight } from "react-icons/bs";

const VehicleCardHome = ({
  id,
  name,
  imageUrl,
  price,
  wheelDrive,
  engineCC,
  mileage,
  fuelType,
  gearType,
  tag,
  make,
  model,
}) => {

  const currency = {
    id: 1,
    name: "LKR"
  }

  return (
    <Link to={`/vehicles/${id}`} className={styles.mainDiv}>
      <div className={styles.carCardTop}>
        {tag && (
          <span
            className={`${styles.tag} ${tag === "FEATURED"
                ? styles.featuredTag
                : tag === "POPULAR"
                  ? styles.popularTag
                  : ""
              }`}
          >
            {tag}
          </span>
        )}
        <div className={styles.imgSec}>
          <img
            className={styles.carImage}
            src={imageUrl || ""}
            alt="car"
          />
        </div>
        <div className={styles.detailsSec}>
          <span className={styles.carName}>{name}</span>

          <span className={styles.carFeatures}>
            {make} | {model} | {wheelDrive} | {engineCC}
          </span>
          <div className={styles.carCardBottom}>
            <div className={styles.carStats}>
              <div>
                <GiSteeringWheel className={styles.icon} size={15} />
                <span>{mileage} km</span>
              </div>
              <div>
                <BsFuelPumpDieselFill className={styles.icon} size={15} />
                <span>{fuelType}</span>
              </div>
              <div>
                <GrManual className={styles.icon} size={15} />
                <span>{gearType}</span>
              </div>
            </div>
          </div>
          <div className={styles.cardFooter}>
            <span className={styles.price}>
              {price ? (
                <span className={styles.priceType}>
                  {currency?.name}{" "}
                </span>
              ) : (
                <span className={styles.priceTypeAsk}>Ask</span>
              )}

              {price && currency?.rate
                ? Math.round(price * currency.rate)
                : ""}
            </span>
            <div className={styles.moreSec}>
              <span className={styles.viewMore}>
                View
              </span>
              <BsArrowUpRight className={styles.arrow} />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default VehicleCardHome;